import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { TaskCard, TaskCardProps } from './TaskCard';

interface SortableTaskCardProps extends TaskCardProps {
  disabled?: boolean;
}

export function SortableTaskCard({ task, disabled, ...props }: SortableTaskCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: task.id,
    disabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <TaskCard
        task={task}
        dragListeners={listeners}
        isDragging={isDragging}
        {...props}
      />
    </div>
  );
}
